module.exports = __webpack_public_path__ + "img/shangchengasa.bd2df1b9.png";